import { FC, memo, useMemo } from 'react'
import { Badge, BadgeProps } from '@chakra-ui/react'

import { STATUS_OBJECT } from 'constants/variables'

type Props = BadgeProps & {
  status?: string
}

const Status: FC<Props> = ({ status, ...rest }) => {
  const { color, text } = useMemo(() => {
    if (!STATUS_OBJECT[status as string]) return STATUS_OBJECT['UNKNOWN']
    return STATUS_OBJECT[status || 'UNKNOWN']
  }, [status])

  return (
    <Badge width="max-content" colorScheme={color} fontSize="xs" {...rest}>
      {text}
    </Badge>
  )
}

export default memo(Status)
